export default __webpack_public_path__ + "static/media/icon-add-team-members.e4276aac.svg";